













import Vue from 'vue';

export default Vue.extend({
  name: 'HMStatus',
  props: {
    active: {
      type: Boolean,
    },
    activeText: {
      type: String,
    },
    inactiveText: {
      type: String,
    },
  },
});
